/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export enum EnergyUsageField {
  BREAKDOWN_BY_SITES = 'breakdownBySite',
  ENERGY_USAGE = 'EnergyUsage',
  CHANGE_USAGE = 'ChangeUsage',
  CARBON = 'CarbonConsumption',
  CARBONTABSITE = 'CarbonTabSite',
  ENERGYUSAGEBREAKDOWN = 'energy-breakdownmeter',
  EUI = 'Eui',
  SITEENERGY = 'Site-Energy',
  PORTFOLIOENERGY = 'Portfolio-Energy',
  PORTFOLIOWATER = 'Portfolio-Water',
  PREMIUMSUBS = 'Premium',
  BASICSUBS = 'Basic',
  NILMENERGYDISAGGREGATION = 'NILMEnergyDisaggregation',
  NILMENERGYUSAGE = 'NILMEnergyUsage',
  NILM = 'nilm',
  UTILITY = 'Utility'
}

export enum CarbonDetailedViewIndex {
  Tab,
  Tab1,
  Tab2
}

export enum EmaasSubscriptionType {
  PREMIUM_SUBSCRIPTION = 'PREMIUM_SUBSCRIPTION',
  BASIC_SUBSCRIPTION = 'BASIC_SUBSCRIPTION',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION'
}

export enum MeterUtilityType {
  WATER = 'Water',
  GAS = 'Gas',
  ELECTRICITY = 'Electricity',
  SEWERAGE = 'Sewerage'
}

export enum SmartPowerSubscriptionType {
  PREMIUM_SUBSCRIPTION = 'PREMIUM_SUBSCRIPTION',
  BASIC_SUBSCRIPTION = 'BASIC_SUBSCRIPTION',
  NO_SUBSCRIPTION = 'NO_SUBSCRIPTION'
}

export enum EnergyUsageDataSourceType {
  UTILITY_METER = 'utilitymeter',
  LIVE_METER = 'livemeter',
  UTILITY_INTERVAL = 'utilityinterval'
}
